import { render, staticRenderFns } from "./ListNew.vue?vue&type=template&id=228f4272&scoped=true&"
import script from "./ListNew.vue?vue&type=script&lang=js&"
export * from "./ListNew.vue?vue&type=script&lang=js&"
import style0 from "./ListNew.vue?vue&type=style&index=0&id=228f4272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f4272",
  null
  
)

export default component.exports